import React from "react";
import {
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import Moment from "react-moment";
import PerfectScrollbar from "react-perfect-scrollbar";
import axios from "../../../Natus/Redux/axios";
import * as Icon from "react-feather";
import $ from "jquery";
import Avatar from "../../../components/@vuexy/avatar/AvatarComponent";
import classnames from "classnames";
import Autocomplete from "../../../components/@vuexy/autoComplete/AutoCompleteComponent";
import { history } from "../../../history";
import { connect } from "react-redux";
import { fetchClinicUser } from "../../../Natus/Redux/clinicUser/ClinicUserActions";
import { fetchPetId } from "../../../Natus/Redux/petInfo/PetIdActions";
import { Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosVeteriner from "../../../axios/axiosVeteriner";
const UserDropdown = (props) => {
  return (
    <DropdownMenu right className="info" cssModule="info" color="info">
      <DropdownItem
        tag="a"
        color="info"
        className="info"
        onClick={(e) => history.push("/VProfileRead")}
      >
        <Icon.User size={14} className="mr-50" />
        <span className="align-middle info ">Profilim</span>
      </DropdownItem>

      <DropdownItem divider />
      <DropdownItem
        tag="a"
        color="info"
        className="info"
        onClick={(e) => history.push("/logout")}
      >
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Çıkış Yap</span>
      </DropdownItem>
    </DropdownMenu>
  );
};

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    suggestions: null,
    username: "",
  };
  handleActiveItem = () => {
    if (document.getElementsByClassName("datam")[0]) {
      const ula = document
        .getElementsByClassName("datam")[0]
        .getAttribute("data-itemid");
      this.props.fetchPetId(parseInt(ula));
    }
  };
  componentWillMount() {
    if (localStorage.natusToken === undefined) {
      history.push("logout");
    } else {
      this.props.fetchClinicUser(this.props.usertoken);
    }
  }
  componentDidMount() {
    if (localStorage.natusToken === undefined) {
      history.push("logout");
    } else {
      this.props.fetchClinicUser(this.props.usertoken);
    }
  }
  searchPetFromApi = (param) => {
    if (param.length >= 1) {
      let config = {
        method: "GET",
      };

      axiosVeteriner
        .get(
          "PetUser/GetPetSearch/",
          {
            params: {
              search: param,
            },
          },
          config
        )
        .then((response) => {
          this.setState({ suggestions: response.data.Result.data });
        })
        .catch((error) => {
          console.log(" error  " + error.message);
        });
    }
  };
  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch,
    });
  };

  render() {
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          pauseOnHover
        />
        <NavItem className="nav-search" onClick={this.handleNavbarSearch}>
          <NavLink className="nav-link-search">
            <Icon.Search size={21} data-tour="search" />
          </NavLink>
          <div
            className={classnames("search-input", {
              open: this.state.navbarSearch,
              "d-none": this.state.navbarSearch === false,
            })}
          >
            <div className="search-input-icon">
              <Icon.Search size={17} className="info" />
            </div>
            <Autocomplete
              className="form-control"
              suggestions={this.state.suggestions}
              filterKey={
                "petRaceDesc" || "petName" || "petUserName" || "petUserPhone"
              }
              //   filterHeaderKey="groupTitle"
              //    grouped={true}
              placeholder="Pet Kimlik No, Pet Adı, Mikroçip No, Sahip Adı, Telefon No vb. ara"
              autoFocus={true}
              clearInput={this.state.navbarSearch}
              externalClick={(e) => {
                this.setState({ navbarSearch: false });
              }}
              onKeyDown={(e) => {
                if (e.keyCode === 38 || e.keyCode === 40) {
                  return false;
                }
                if (e.keyCode === 27 || e.keyCode === 13) {
                  this.handleActiveItem();
                  this.setState({
                    navbarSearch: false,
                  });
                  this.props.handleAppOverlay("");
                }
              }}
              onChange={(e) => {
                this.searchPetFromApi(e.target.value);
              }}
              customRender={(
                item,
                i,
                filteredData,
                activeSuggestion,
                onSuggestionItemClick,
                onSuggestionItemHover
              ) => {
                const IconTag = Icon[item.icon ? item.icon : "X"];
                if (filteredData === null) {
                  return (
                    <a>
                      <li>
                        <div
                          className={classnames(
                            "d-flex justify-content-between align-items-center"
                          )}
                        >
                          <div className="item-container d-flex">
                            <div className="item-info ml-1">
                              <p className="align-middle mb-0">
                                <p className="align-middle mb-0">
                                  Pet Bulunamadı
                                </p>
                              </p>
                            </div>
                          </div>

                          <div className="meta-container">
                            <small className="text-muted"></small>
                          </div>
                        </div>
                      </li>
                    </a>
                  );
                } else {
                  return (
                    <a>
                      <li
                        className={classnames("acti suggestion-item", {
                          // active:
                          //   filteredData.indexOf(item) === activeSuggestion,
                          datam:
                            filteredData.indexOf(item) === activeSuggestion,
                        })}
                        key={i}
                        onClick={(e) => {
                          this.props.fetchPetId(item.id);
                          onSuggestionItemClick("hastadetay", e);
                        }}
                        onKeyDown={(e) => {
                          if (e === 13) {
                            this.props.fetchPetId(item.id);
                            onSuggestionItemClick("hastadetay", e);
                          }
                        }}
                        onInput={() => {
                          this.props.fetchPetId(item.id);
                        }}
                        data-itemid={item.id}
                      >
                        <div
                          className={classnames({
                            "d-flex justify-content-between align-items-center":
                              item.petImageUrl,
                          })}
                        ></div>
                        <div className="item-container d-flex">
                          <Avatar
                            className="mr-1"
                            img={item.petImageUrl}
                            size="sm"
                          />

                          <div className="item-info ml-1">
                            <p className="align-middle mb-0">
                              {" "}
                              {item.petName}/{"  "} {item.nfcId}{" "}
                            </p>
                            <small className="text-muted">
                              {item.petSexDesc} / {item.petKindDesc} /
                              {item.petRaceDesc} / Doğum Tarihi{" "}
                              <Moment format="DD.MM.YYYY">
                                {item.petBirthDate}
                              </Moment>
                            </small>
                          </div>
                        </div>
                        <div className="meta-container float-right"></div>
                      </li>
                    </a>
                  );
                }
              }}
              onSuggestionsShown={(userInput) => {
                if (this.state.navbarSearch) {
                  this.props.handleAppOverlay(userInput);
                }
              }}
            />
            <div className="search-input-close">
              <Icon.X
                size={24}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    navbarSearch: false,
                  });
                  this.props.handleAppOverlay("");
                }}
              />
            </div>
          </div>
        </NavItem>

        <UncontrolledDropdown tag="li" className="dropdown-user nav-item info">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600">
                {this.props.clinicUserinfo
                  ? this.props.clinicUserinfo.name
                  : ""}{" "}
                {this.props.clinicUserinfo
                  ? this.props.clinicUserinfo.surname
                  : ""}
              </span>
              <span className="user-status"> </span>
            </div>
            <span data-tour="user">
              <img
                src={
                  this.props.clinicUserinfo
                    ? this.props.clinicUserinfo?.profileImagePath
                    : "https://akillitasmafilestorage.blob.core.windows.net/img/no-image.png"
                }
                className="round"
                height="40"
                width="40"
                alt="petinoks"
              />
            </span>
          </DropdownToggle>
          <UserDropdown {...this.props} className="info" />
        </UncontrolledDropdown>
      </ul>
    );
  }
}
const mapstateToProps = (state) => {
  return {
    clinicUserinfo: state.clinicUser.clinicUserinfo,
    usertoken: state.user.usertoken,
    petId: state.petId.id,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchClinicUser: (a) => dispatch(fetchClinicUser(a)),
    fetchPetId: (b) => dispatch(fetchPetId(b)),
  };
};

export default connect(mapstateToProps, mapDispatchToProps)(NavbarUser);
